import { render, staticRenderFns } from "./Actualite.vue?vue&type=template&id=6c5c4465&scoped=true&"
import script from "./Actualite.vue?vue&type=script&lang=js&"
export * from "./Actualite.vue?vue&type=script&lang=js&"
import style0 from "./Actualite.vue?vue&type=style&index=0&id=6c5c4465&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c4465",
  null
  
)

export default component.exports